import { ASSETS, CLUSTER_ASSETS } from '@/layers'
import layerService from '@/layers/layerService'
import { updateAssetIdLayer } from '@/layers/asset-id/asset-id-layer'
import { ASSETS_IDS_LAYER } from '@/layers/constant'
import { usePlanStore } from '@/store/plan'

export function shouldAssetSimpleLayerBeVisible(
  switchLayersZoomValue: number,
  currentZoom: number,
): boolean {
  return currentZoom >= switchLayersZoomValue
}

export function manageAssetsLayersVisibility(
  switchLayersZoomValue: number,
  currentZoom: number,
  viewState: unknown,
) {
  // If assets layers is hidden do nothing
  if (
    !layerService.isVisible(CLUSTER_ASSETS) &&
    !layerService.isVisible(ASSETS)
  ) {
    return
  }

  const zoomValue = currentZoom
  // console.debug('manageAssetsLayersVisibility', switchLayersZoomValue, currentZoom, zoomValue)
  layerService.setZoom(zoomValue)
  if (
    zoomValue >= switchLayersZoomValue &&
    layerService.isVisible(CLUSTER_ASSETS)
  ) {
    console.debug('🔷 Switching to Simple Assets Layer')
    layerService.hideLayer(CLUSTER_ASSETS, {}, false)
    layerService.showLayer(ASSETS, {}, false)
  } else if (
    zoomValue < switchLayersZoomValue &&
    layerService.isVisible(ASSETS)
  ) {
    console.debug('🔶 Switching to Cluster Asset Layer')
    // NO a flyTo en plan compartido
    layerService.hideLayer(ASSETS, {}, false)
    layerService.showLayer(CLUSTER_ASSETS, { flyToExtent: false }, false)
  }

  const isAssetsIdsLayerVisible = usePlanStore().getAssetsIdsLayerVisibility
  if (isAssetsIdsLayerVisible) {
    if (zoomValue >= switchLayersZoomValue) {
      updateAssetIdLayer({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        viewState: viewState as any,
        zoomLayerForDeclustering: switchLayersZoomValue,
      })
    } else {
      layerService.removeLayer(ASSETS_IDS_LAYER, false)
    }
  }

  layerService.updateDeckInstance()
}
